import * as React from "react";
import { Grid, Link } from "@mui/material";

// settings
import { AuthenticationContext } from "../Context";
import { getHeaders } from "../utils/HeaderHelper";
import { checkPrivileges } from "../utils/PrivilegesHelper";
import { PrivilegesContext } from "../PrivilegesContext";
import { useCustomerPermission } from "../hooks/useCustomerPermission";

interface Props {}

const AdminFunctions: React.FC<Props> = (props: any) => {
  //  auth context
  const authenticationSetting = React.useContext(AuthenticationContext);
  const userPrivileges = React.useContext(PrivilegesContext);
  const currentUser = authenticationSetting.currentUser;

  const { permitted: useBillingPermitted } =
    useCustomerPermission("Billing Access");

  const [featureFlags, setFeatureFlags] = React.useState<any>("");

  React.useEffect(() => {
    getFeatureFlags();
  }, []);

  const getFeatureFlags = () => {
    fetch(`/feature_flags`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.message);
        } else {
          setFeatureFlags(result?.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="adminFunctions">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid
          container
          item
          xs={12}
          sm={6}
          lg={4}
          xl={3}
          className="userAdminInformation"
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <h3 style={{ textAlign: "center", marginBottom: 30 }}>Settings</h3>
            {featureFlags?.FEATURE_ACTION_BUILDER_ON == "true" && (
              <Link href="/action-builder-list" className="menuLink">
                Action Builder
              </Link>
            )}
            {featureFlags?.FEATURE_ACTION_SETTINGS_ON == "true" && (
              <Link href="/action-settings" className="menuLink">
                Action Queue Settings
              </Link>
            )}
            {checkPrivileges(userPrivileges, "Bulk Patient Upload") && (
              <Link href="/patient-upload" className="menuLink">
                Bulk Data Upload
              </Link>
            )}
            <Link
              href="/resource-catalog"
              className={`${
                checkPrivileges(userPrivileges, "Access Resource Catalog")
                  ? "menuLink"
                  : "menuLinkDisabled"
              }`}
            >
              Catalog
            </Link>
            {useBillingPermitted &&
              checkPrivileges(
                userPrivileges,
                "Access Claim Template Builder"
              ) && (
                <Link href="/claim-template-builder" className="menuLink">
                  Claim Template Builder
                </Link>
              )}
            <Link href="/templates-list" className="menuLink">
              Encounter Template Builder
            </Link>
            <Link
              href="/facilities"
              className={`${
                checkPrivileges(
                  userPrivileges,
                  "Access Living Facility Builder"
                )
                  ? "menuLink"
                  : "menuLinkDisabled"
              }`}
            >
              Living Facility Builder
            </Link>
            {checkPrivileges(
              userPrivileges,
              "Enable Login Page Content Management"
            ) && (
              <Link href="/login-page-content" className={`menuLink`}>
                Login Page Content
              </Link>
            )}
            {checkPrivileges(userPrivileges, "Access NDM Reporting") && (
              <Link href="/ndm-report" className="menuLink">
                NDM Reporting
              </Link>
            )}
            {currentUser?.starfield_admin && (
              <Link href="/customer-list" className="menuLink">
                Organizations
              </Link>
            )}
            {useBillingPermitted &&
              checkPrivileges(userPrivileges, "Access Pricing Table") && (
                <Link href="/pricing-tables" className="menuLink">
                  Pricing Tables
                </Link>
              )}
            {featureFlags?.FEATURE_PROGRAM_BUILDER_ON == "true" && (
              <Link href="/program-builder" className="menuLink">
                Program Builder
              </Link>
            )}
            <Link href="/user-administration" className="menuLink">
              Providers
            </Link>

            <Link
              href="/questionnaires-list"
              className={`${
                checkPrivileges(userPrivileges, "Build Questionnaire")
                  ? "menuLink"
                  : "menuLinkDisabled"
              }`}
            >
              Questionnaire Builder
            </Link>
            <Link
              href="/reports"
              className={`${
                checkPrivileges(userPrivileges, "Access Reporting")
                  ? "menuLink"
                  : "menuLinkDisabled"
              }`}
            >
              Reports
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default AdminFunctions;
